import React from "react";
import {
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { formatTimeString2 } from "./utils";
import * as S from "./styles";

function TimeSlotList({ preset, setPreset, shiftsData }) {
  const handleUpdateSchedule = (scheduleId, field, value) => {
    setPreset((prevPreset) => ({
      ...prevPreset,
      schedules: prevPreset.schedules.map((schedule) => {
        if (schedule.id === scheduleId) {
          return { ...schedule, [field]: value };
        }
        return schedule;
      }),
    }));
  };
  const handleDeleteSchedule = (scheduleId) => {
    setPreset({
      ...preset,
      schedules: preset.schedules.filter(
        (schedule) => schedule.id !== scheduleId
      ),
    });
  };
  console.log("TimeSlotList preset.schedules:", preset.schedules);

  return (
    <S.TimeSlotPreset>
      {preset.schedules.map((schedule) => (
        <S.EditableTimeSlotPreset key={schedule.id}>
          <S.TimeDisplayPreset>
            <S.CompactTimeInputPreset
              type="time"
              value={formatTimeString2(schedule.start)}
              onChange={(e) =>
                handleUpdateSchedule(schedule.id, "start", e.target.value)
              }
              size="small"
            />
            <Typography variant="body2">~</Typography>
            <S.CompactTimeInputPreset
              type="time"
              value={
                schedule.isUntilMidnight
                  ? "00:00"
                  : formatTimeString2(schedule.end)
              }
              onChange={(e) =>
                handleUpdateSchedule(schedule.id, "end", e.target.value)
              }
              size="small"
              disabled={schedule.isUntilMidnight}
            />
            <S.CheckboxWrapper>
              <input
                type="checkbox"
                checked={schedule.isUntilMidnight || false}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  handleUpdateSchedule(
                    schedule.id,
                    "isUntilMidnight",
                    isChecked
                  );
                  if (isChecked) {
                    handleUpdateSchedule(schedule.id, "end", "24:00");
                  } else {
                    handleUpdateSchedule(schedule.id, "end", "18:00");
                  }
                }}
              />
              <Typography variant="body2">24시까지</Typography>
            </S.CheckboxWrapper>
            <FormControl
              size="small"
              sx={{
                minWidth: 160,
                ml: 2,
                "& .MuiInputLabel-root": {
                  color: "text.primary",
                },
              }}
            >
              <InputLabel id={`shift-select-label-${schedule.id}`}>
                조업 구분 선택
              </InputLabel>
              <Select
                labelId={`shift-select-label-${schedule.id}`}
                label="조업 구분 선택"
                value={schedule.shift_id ?? ""}
                onChange={(e) =>
                  handleUpdateSchedule(schedule.id, "shift_id", e.target.value)
                }
              >
                <MenuItem value="" disabled>
                  <em>적용할 조업 구분을 선택해주세요.</em>
                </MenuItem>
                {shiftsData?.map((shift) => (
                  <MenuItem key={shift.shift_id} value={shift.shift_id}>
                    {shift.shift_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </S.TimeDisplayPreset>
          {preset.schedules.length > 1 && (
            <IconButton
              size="small"
              onClick={() => handleDeleteSchedule(schedule.id)}
              color="error"
            >
              <CloseIcon />
            </IconButton>
          )}
        </S.EditableTimeSlotPreset>
      ))}
    </S.TimeSlotPreset>
  );
}

export default TimeSlotList;
